import { useMutation } from '@tanstack/react-query';
import { get } from 'lodash';
import { useUser } from 'common/context/UserContext';
import { useApi } from 'common/hooks/api';
import { safeSingleMediaContentToUrl } from 'common/helpers/content';
import { ZAPS, zapDealId, savedItineraryTagLabel, MONTH_NAMES } from 'itrvl-types';
import { csvQuoteIds } from 'common/utils/itineraries';

// @todo: this could probably be moved to the backend
export const useClientPortalSharedZap = () => {
  const Api = useApi();
  const userContext = useUser();
  const mutation = useMutation({
    mutationFn: ({ itineraries }) => {
      Api.zap(ZAPS.CLIENT_PORTAL_SHARED, userContext, { quoteId: csvQuoteIds(itineraries) });
    },
  });
  return mutation;
};

// @todo: this could probably be moved to the backend
export const useImportBookingZap = () => {
  const Api = useApi();
  const userContext = useUser();
  const mutation = useMutation({
    mutationFn: ({ importId, quoteId, wwKey }) => {
      Api.zap(ZAPS.QUOTE_IMPORTED, userContext, { quoteId, wwKey }, `${window.location.origin}/itinerary/${importId}`);
    },
  });
  return mutation;
};

export const useEdgeEnquiryZap = () => {
  const Api = useApi();
  const userContext = useUser();
  const mutation = useMutation({
    mutationFn: formData => {
      const agency = userContext?.user?.agency;
      const payload = {
        ...zapDealId(userContext?.client),
        'Agent Name': get(userContext, 'user.agent.fullName', `${get(userContext, 'user.firstName')} ${get(userContext, 'user.lastName')}`),
        'Agent Email': get(userContext, 'user.agent.email', get(userContext, 'user.email')),
        'Agency Code': agency?.agencyCode,
        'Agency Name': agency?.name,
        'Wilderness Sales Email': agency?.consultantEmail,
        'Wilderness Operations Email': agency?.emails?.wildernessOperations,
        'Agency Sales Email': agency?.emails?.agencySales,
        'Agency Operations Email': agency?.emails?.agencyOperations,
        'Agency Dark Logo URL': safeSingleMediaContentToUrl(agency?.logoDark),
        'Agency Main Brand Color': agency?.backgroundColor,
        'Agency Button and Icon Color': agency?.secondaryThemeColor,
        'Client name': formData.client?.name || formData.client,
        'Client email': formData.email,
        WWKey: userContext?.client?.wwKey,
        'Party ID': userContext?.client?.dealId,
        Destinations: formData.destinations?.join(', '),
        'Destination Mode': formData.destinationMode,
        'Other Destination': formData.otherDestination,
        'Travel Months': formData.selectedMonths?.map(i => MONTH_NAMES[i]).join(', '),
        'Travel Year': formData.selectedYear,
        'Start Date': formData.startDate,
        'End Date': formData.endDate,
        'Trip Duration': formData.duration,
        'Date Mode': formData.dateMode,
        Adults: formData.adults,
        Children: formData.children,
        'Children Ages': formData.childrenAges?.join(', '),
        Budget: formData.budget,
        'Trip Types': formData.tripTypes?.map(savedItineraryTagLabel).join(', '),
        Notes: formData.notes,
      };
      return Api.zap(ZAPS.EDGE_ENQUIRY, userContext, {}, null, payload);
    },
  });
  return mutation;
};
